export default {
  methods: {
    scrollTo: (id, block) => {
      const element = document.querySelector(id);
      if (element && block) {
        element.scrollIntoView({ behavior: 'smooth', block: block });
      } else if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }
}
